<form [formGroup]="passwordChangeForm">
  <div class="rt-row">
    <div class="rt-column desk-12"> 
      <p>
        You’re logged in, but please set a new password to secure your account. It only takes a moment!
      </p>
    </div>
    <div class="rt-column desk-12">        
      <div class="field">
        <label for="password">New password</label>
        <p-password
          [fluid]="true"
          [toggleMask]="true"
          id="password" 
          formControlName="password"
          autocomplete="new-password"
          placeholder="Enter a new password"
        />
        @if (
          passwordChangeForm.controls['password'].touched &&
          passwordChangeForm.controls['password'].hasError('required')
        ) {
          <div class="error-message">Password is required</div>
        }
        @if (
          passwordChangeForm.controls['password'].touched &&
          passwordChangeForm.controls['password'].hasError('pattern')
        ) {
          <div class="error-message">Password is not in correct format</div>
        }
        <small>Use 8 or more characters with a mix of letters, numbers & symbols</small>
      </div> 
    </div>
  </div>
</form>
<div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 12px;">
  <p-button
    (click)="close()"
    severity="secondary"
    [rounded]="true"
    label="Close"
  ></p-button>
  <p-button
    (click)="submit()"
    severity="primary"
    [rounded]="true"
    label="Submit"
    [disabled]="passwordChangeForm.invalid"
    [loading]="saving()"
  ></p-button>
</div>